'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

export default function HeroSection() {
  const t = useTranslations('page_cam_ket_phat_trien')
  return (
    <section className="bg-[url('https://media.coolmate.me/image/November2024/mceclip3_85.png')] bg-cover bg-right bg-no-repeat md:bg-[url('https://media.coolmate.me/image/November2024/mceclip2_60.png')]">
      <section className='flex w-full flex-col items-center justify-center'>
        <picture style={{ width: '100%' }}>
          <source
            srcSet={ImageHelper.getImageUrlCdn(
              '/image/December2024/mceclip1_79.png'
            )}
            media='(max-width: 768px)'
          />
          <Image
            src={ImageHelper.getImageUrlCdn(
              '/image/December2024/mceclip0_64.jpg'
            )}
            className='w-auto object-cover'
            width={1920}
            height={600}
            alt={t('hero.banner_alt')}
          />
        </picture>
      </section>
      <section className='container mx-auto flex w-full flex-col items-center justify-center px-4 py-10 font-criteria text-base font-normal md:py-20 md:text-2xl'>
        <p className='px-5 text-center font-criteria text-[22px] font-medium leading-none md:text-[44px]'>
          {t.rich('hero.headline', {
            brMd: () => <br className='hidden md:block' />,
          })}
        </p>
        <p className='mt-4 text-center font-criteria text-sm font-normal md:mt-10 md:text-2xl'>
          {t.rich('hero.description', {
            br2xl: () => <br className='hidden 2xl:block' />,
          })}
        </p>
      </section>
    </section>
  )
}
